export class EstructuraBase<T> {
    value: T;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    callback:number;
    origenCallBack:string;
    depende:number;
    maxlength:number;
    minlength:number;
    email: number;
    number:number;
    parametroDestino:string;
    hijoDate:string;
    padreDate:string;
    type: string;

    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        callback?:number,
        origenCallBack?:string,
        depende?:number,
        maxlength?:number,
        minlength?:number,
        email?: number,
        number?:number,
        parametroDestino?:string,
        hijoDate?:string,
        padreDate?:string,
        type?: string
    } = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.callback = options.callback === undefined ? 1 : options.callback;
        this.origenCallBack = options.origenCallBack || '';
        this.depende = options.depende === undefined ? 1 : options.depende;
        this.maxlength = options['maxlength'] === undefined ? 1 : options['maxlength'];
        this.minlength = options['minlength'] === undefined ? 1 : options['minlength'];
        this.email = options['email'] === undefined ? 1 : options['email'];
        this.number = options['number'] === undefined ? 1 : options['number'];
        this.parametroDestino=options.parametroDestino || '';
        this.hijoDate=options.hijoDate || '';
        this.padreDate=options.padreDate || '';
        this.type=options.type || '';
    }
}
